/**
 * IE11を判定する
 */
export default class EnvDetector {
  ua;

  constructor() {
    // UserAgent を取得し、全て小文字にする
    this.ua = window.navigator.userAgent.toLowerCase();

    // もしIEの場合は、body タグに「ie11」クラスを追加する
    if (this.isIE()) {
      this.addIEClass();
    }
  }

  /**
   * Internet Explorerかどうかを判定する
   * @returns {boolean}
   */
  isIE() {
    return (this.ua.indexOf('msie') >= 0 || this.ua.indexOf('trident') >= 0);
  }

  /**
   * body タグに「ie11」クラスを追加する
   */
  addIEClass() {
    // IEのバージョンを、正規表現で取得する.
    var array = /(msie|rv:?)\s?([\d.]+)/.exec(this.ua);
    var version = (array) ? array[2] : '';

    // バージョンを整数の形式にする（11.0 -> 11）
    version = version.split('.')[0];

    // バージョン関係なくIE用のCSSを追加
    window.document.body.classList.add('ie');

    if (version === '11') {
      window.document.body.classList.add('ie11');
    }
  }
}
